import { UpdateTestDto } from "../../api/models";
import { BookingStatus } from "../../enums/booking-status.enum";
import { BookingPrescriptionState } from "../../interfaces/booking-prescription-state.interface";

/**
 * Maps the booking prescription state to a partial DTO used to update an existing test.
 * @param state - The current booking state, possibly containing updated fields.
 * @returns A UpdateTestDto object to update only the necessary fields.
 */
export function mapBookingPrescriptionStateToUpdateDto(
  state: BookingPrescriptionState,
): UpdateTestDto {
  return {
    clinicId: state.clinicId || "",
    clinicName: state.clinicName || "",
    clinicEmail: state.clinicEmail || "",
    patientId: state.patientId!,
    patientFirstName: state.patientFirstName,
    patientLastName: state.patientLastName,
    bookingDate: state.bookingDate,
    status: BookingStatus.SCHEDULED,
    price: state.price,
    isExternal: state.isExternal,
  };
}
